



import Base from "@/template/public/Base.vue";
export default class ColumnDetail extends Base {}
